import { DISTANCE_TOLERANCE } from "../../../utilities/line-profile-geometry-utils";
/**
 * Classify each PVI as linked to an IP point or free.
 * A PVI links to the first IP point (in `ipDistances` order) whose horizontal distance differs by less than DISTANCE_TOLERANCE.
 */
export function linkPvisToIps(pvis, ipDistances) {
    return pvis.map((pvi) => {
        const matched = ipDistances.find((ip) => Math.abs(ip.horizontalDistance - pvi.horizontalDistance) <
            DISTANCE_TOLERANCE);
        return matched
            ? { kind: "ip", ipId: matched.ipId, pvi }
            : { kind: "free", pvi };
    });
}
/**
 * Rebuild PVIs after an edit.
 * Linked PVIs move to their IP point's new horizontal distance (dropped if the IP point is gone); free PVIs scale by newLength / oldLength.
 * Elevation is kept; result is stably sorted by horizontalDistance.
 */
export function relocatePvis(links, newIpDistances, oldLength, newLength) {
    const distanceById = new Map(newIpDistances.map((ip) => [ip.ipId, ip.horizontalDistance]));
    const relocated = [];
    for (const link of links) {
        if (link.kind === "ip") {
            const horizontalDistance = distanceById.get(link.ipId);
            if (horizontalDistance === undefined) {
                continue;
            }
            relocated.push({ ...link.pvi, horizontalDistance });
        }
        else {
            relocated.push({
                ...link.pvi,
                horizontalDistance: (link.pvi.horizontalDistance / oldLength) * newLength,
            });
        }
    }
    return relocated.sort((a, b) => a.horizontalDistance - b.horizontalDistance);
}
//# sourceMappingURL=pvi-ip-link.js.map